import {SagaIterator} from 'redux-saga';
import {valid} from 'node-html-parser';
import {putResolve, call} from 'redux-saga/effects';

import {PRODUCT_BANNER_PLACEHOLDER} from 'constants/product';

import {fetchProductBanner} from 'actions/product/banner/banner';
import {logWithSentry} from 'libs/sentry/sentry';

/**
 * Validates received banner markup
 * @param {Action} fetchProductBannerAction - request to CMS banner action
 * @returns {boolean} - validation verdict of banner markup
 */
export const validateProductBanner = async fetchProductBannerAction => {
    const response = await fetchProductBannerAction.payload;

    return valid(response?.data?.banner);
};

/**
 * Displays the banner
 * @param {number} productId - current product id
 */
export function* displayBanner(productId: number): SagaIterator {
    const fetchProductBannerAction = yield call(
        fetchProductBanner,
        PRODUCT_BANNER_PLACEHOLDER,
        productId,
    );

    const isBannerValid = yield call(validateProductBanner, fetchProductBannerAction);

    if (isBannerValid) {
        yield putResolve(fetchProductBannerAction);
    } else {
        yield call(
            logWithSentry,
            new Error('Product CMS banner has invalid HTML markup'),
            `product identifier: ${productId}`,
        );
    }
}
